import { DateTime } from '@mode-switch/express';
import { SwitchAttrsDomain, SwitchViewDomain, SwitchViewResponseTypes } from '@mode/shared/contract-common';

export function toSwitchView(
  response: SwitchViewResponseTypes.SwitchViewResource,
  attrResources: ReadonlyArray<SwitchViewResponseTypes.SwitchViewAttrResource> | undefined
): SwitchViewDomain.SwitchView {
  let attrs: SwitchViewDomain.SwitchAttr[] = [];

  if (attrResources != null) {
    attrs = attrResources.map((r) => toSwitchAttr(r as SwitchViewResponseTypes.SwitchViewAttrResource));
  }

  return {
    token: response.token,
    createdAt: response.created_at,
    updatedAt: response.updated_at,
    sourceToken: response.source_token,
    sourceType: response.source_type,
    switchAttrs: attrs,
    flamingoSignature: response.flamingo_signature,
    orphan: response.orphan,
    rootModelIsSample: response.root_model_is_sample,
    rootSourceExists: response.root_source_exists,
    rootSourceModelName: response.model_name ?? '',
    rootSourceModelType: response.model_type ?? '',
    isDataRefreshAvailable: response.data_refresh_available ?? false,
    isFallbackData: response.last_source_run_failed ?? false,
    producerType: response.producer_type ?? null,
    producerToken: response['producer_token'],
    weekStart: DateTime.weekStart(response.week_start),
    yearStart: DateTime.yearStart(response.year_start),
    error: false,
    rowOrder: response.row_order ?? null,
  };
}

export function toSwitchAttr(resource: SwitchViewResponseTypes.SwitchViewAttrResource): SwitchAttrsDomain.SwitchAttr {
  return {
    createdAt: resource.created_at,
    desc: resource.desc,
    formulaSource: resource.formula_source,
    formulaType: resource.formula_type,
    name: resource.name,
    role: resource.role,
    scale: resource.scale,
    source: resource.source,
    token: resource.token,
    switchViewToken: resource.switch_view_token,
    isLocal: resource.is_local,
    type: resource.type,
    updatedAt: resource.updated_at,
    formulaRole: resource.formula_role,
    color: resource.color,
    format: resource.format,
    defaultsAggregate: resource.defaults_aggregate,
  };
}

export function toSwitchViewRunState(
  resource: SwitchViewResponseTypes.SwitchViewRunStateResource
): SwitchViewDomain.SwitchViewRunState {
  return {
    token: resource.token,
    type: resource.type,
    state: resource.state,
  };
}

/**
 * Helper function to validate whether a dataset embed is present on a SwitchViewResource.
 */
export function switchViewResourceHasDataset(switchViewResource: SwitchViewResponseTypes.SwitchViewResource): boolean {
  const embeds = switchViewResource._embedded;
  if (
    embeds &&
    ('last_data_run' in embeds || 'last_successful_data_run' in embeds || 'data_run_for_run_in_context' in embeds)
  ) {
    return true;
  }

  return false;
}
